import React from 'react';

interface SpeakersPreviewModuleHeadProps {
  bucket_group?: string;
  getImage: Function;
  openPopover: Function;
  partnerBucket?: string;
  user?: object;
  speaker?: object;
}

const SpeakersPreviewModuleHead: React.FC<SpeakersPreviewModuleHeadProps> = ({
  getImage,
  openPopover,
  partnerBucket,
  user,
  speaker,
}) => {
  const showPopover = () => {
    if (user) {
      openPopover(user);
    } else {
      //@ts-ignore
      openPopover(speaker.content_id);
    }
  };

  const getImgUrl = () => {
    if (user) {
      //@ts-ignore
      return 'url("' + getImage(user.Icon) + '")';
    } else {
      //@ts-ignore
      return 'url("' + getImage(speaker.content_icon) + '")';
    }
  };

  const getName = () => {
    if (user) {
      if (CrowdHub_App.CONFIG.USER_PRIVACY_TOGGLE) {
        return user.Firstname;
      } else {
        return user.Firstname + ' ' + user.Lastname;
      }
    } else {
      return speaker.content_name;
    }
  };

  const displaySpeakerImages = () => {
    if (speaker) {
      //@ts-ignore
      if (speaker.bucket_group == partnerBucket) {
        return (
          <div className="background_image_container partner_ratioed ui_relative center_withmargins">
            <div
              style={{
                backgroundImage: getImgUrl(),
              }}
              className="background_image cover ui_full_width ui_full_height ui_absolute"
            ></div>
          </div>
        );
      }
    }
    return (
      <div className="background_image_container ui_relative center_withmargins">
        <div
          style={{
            backgroundImage: getImgUrl(),
          }}
          className="background_image cover ui_full_width ui_full_height ui_absolute"
        ></div>
      </div>
    );
  };
  return (
    <div onClick={showPopover} className="user_head">
      {displaySpeakerImages()}
      <div className="slide_title ui_textalign_center">{getName()}</div>
    </div>
  );
};

export default SpeakersPreviewModuleHead;
